export const CACHE_KEYS = {
  AUTH: {
    TOKEN: "auth_token",
    STATE: "auth_state",
  },
  SESSION: {
    ACCOUNT: "account_session",
  },
  AI: {
    AUDIT_LOGS: "ai_audit_logs",
  },
} as const;

export const CACHE_OPTIONS = {
  AUTH: {
    STATE: {
      expirationDays: 7, // Estado de autenticação expira em 7 dias
    },
  },
  SESSION: {
    ACCOUNT: {
      expirationDays: 1, // Sessão expira em 1 dia
    },
  },
  AI: {
    AUDIT_LOGS: {
      expirationDays: 7, // Logs expiram em 7 dias
    },
  },
} as const;
